import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {FaHome,} from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropertyCard from "../../../components/Shared/PropertyCard";
import { useTranslateKey } from "../../../components/translation/useTranslateKey";
import { LangContext } from "../../../components/translation/langugeContext";

const FeaturedProperties = ({ featuredProperties, projects }) => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const navigate = useNavigate();
  const t = useTranslateKey();
  const { lang } = useContext(LangContext);

  const handleClick = (featured) => {
    navigate(`/property-browser?filter_type=${featured}`);
  };
  const filter_type = "featured";
  return (
    <section
      id="featured"
      className="pt-32 mt-24 pb-16 bg-gradient-to-b from-[#121525] via-[#121525]/95 to-[#121525] relative"
    >
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2
            style={{ color: "#F9C835" }}
            className="text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center gap-3"
          >
            <FaHome style={{ color: "#F9C835" }} />
            <span style={{ color: "#F9C835" }}>{t("featuredPropertiesTitle")}</span>
          </h2>
        </div>

        {featuredProperties && featuredProperties.length > 0 ? (
          <Slider {...sliderSettings}>
            {featuredProperties.map((property) => (
              <div key={property.id} className="px-2">
                {" "}
                <PropertyCard
                  property={property}
                  projects={projects}
                  customClass={lang === "ar" ? "flags-container-home-ar" : "flags-container-home"}
                />
              </div>
            ))}
          </Slider>
        ) : (
          <div className="col-span-full text-center text-white py-12">
            {t("noProjectsFound")}
          </div>
        )}

        <div className="view-all-btn-container">
          <button
            onClick={() => handleClick(filter_type)}
            className="view-all-btn cursor-pointer rounded-lg text-sm font-medium flex transition-all duration-300 primary-active"
          >
            {t("viewFeaturedPropertiesLabel")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProperties;
